import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import { DepartmentSerializer } from "@/types/department"
import { fetchDepartments } from "@core/api/departmentApi"

interface DepartmentState {
  departments: DepartmentSerializer[] | null
  loading: boolean
  error: string | null
}

const initialState: DepartmentState = {
  departments: null,
  loading: false,
  error: null,
}

const departmentSlice = createSlice({
  name: "department",
  initialState,
  reducers: {
    clearDepartments(state) {
      state.departments = null
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchDepartments.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchDepartments.fulfilled, (state, action) => {
        state.loading = false
        state.departments = action.payload
      })
      .addCase(fetchDepartments.rejected, (state, action) => {
        state.loading = false
        state.departments = null
        state.error = (action.payload as string) || action.error.message || "알 수 없는 오류 발생"
      })
  },
})

export const { clearDepartments, setLoading, setError } = departmentSlice.actions

export default departmentSlice.reducer
